/** @jsx jsx */

import { Fragment } from 'react';

import { jsx } from '@emotion/core';

import GuideSection from './GuideSection';
import { GUIDE_SECTIONS } from './constants';
import { useSidebarRight } from '../Provider';
import { Body, Footer, Header, Wrapper } from '../Layout';
import {
  COMMON_SECTION_IDS,
  GUIDE_SECTION_IDS as SIDEBAR_RIGHT_GUIDE_SECTION_IDS,
  MODES as SIDEBAR_RIGHT_MODES,
  TABS as SIDEBAR_RIGHT_TABS,
} from '../constants';

type Props = {
  onClose: () => void;
  activeSubSection?: string;
};

const Guide = (props: Props) => {
  const { update: updateSidebarRight, activeSubsection } = useSidebarRight();

  const setGuideToHome = () => {
    updateSidebarRight({
      mode: SIDEBAR_RIGHT_MODES.DEFAULT,
      tabActive: SIDEBAR_RIGHT_TABS.GUIDE,
      activeSubsection: COMMON_SECTION_IDS.NONE,
    });
  };

  const handleClickSection = (sectionId: SIDEBAR_RIGHT_GUIDE_SECTION_IDS) => {
    updateSidebarRight({
      activeSubsection: sectionId,
    });
  };

  const guideSection = GUIDE_SECTIONS.find(
    section => section.id === activeSubsection
  );

  return (
    <Wrapper>
      {activeSubsection !== COMMON_SECTION_IDS.NONE ? (
        <Fragment>
          <Header
            onBack={setGuideToHome}
            onClose={props.onClose}
            onHome={setGuideToHome}
            title="Guide"
          />
          <Body padding={0}>
            <GuideSection
              content={guideSection.content}
              icon={guideSection.icon}
              iconBackgroundColor={guideSection.iconBackgroundColor}
              key={guideSection.title}
              title={guideSection.title}
            />
          </Body>
        </Fragment>
      ) : (
        <Fragment>
          <Header onClose={props.onClose} title="Guide" />
          <Body padding={0}>
            {GUIDE_SECTIONS.map(section => {
              return (
                <GuideSection
                  content={section.contentCondensed}
                  icon={section.icon}
                  iconBackgroundColor={section.iconBackgroundColor}
                  isCondensed={true}
                  key={section.title}
                  onClick={() => handleClickSection(section.id)}
                  title={section.titleCondensed}
                />
              );
            })}
          </Body>
        </Fragment>
      )}
      <Footer />
    </Wrapper>
  );
};

export default Guide;
